var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomDataDownload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "192px",
    viewBox: "0 0 240 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Download_Static") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download_Static"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Download",
    fill: "#FFFFFF",
    x: 5,
    y: 6,
    width: 230,
    height: 180
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_Static",
    fill: "#D9E8F6",
    stroke: "#D9E8F6",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C10.4771525,6 6,10.4771525 6,16 L6,176 C6,181.522847 10.4771525,186 16,186 L224,186 C229.522847,186 234,181.522847 234,176 L234,16 C234,10.4771525 229.522847,6 224,6 L16,6 Z M9,10 L231,10 L231,182 L9,182 L9,10 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94,133 L94,107 L146,107 L146,133 L178,133 L120,191 L62,133 L94,133 Z",
    id: "Combined-Shape-DownArrow",
    fill: "#B49859"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Checkbox-Area",
    fill: "#ffffff",
    x: 15,
    y: 16,
    width: 210,
    height: 91
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(27.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(83.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(104.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(146.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(0.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(41.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(125.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(167.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(62.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(62.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(83.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(146.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(167.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(41.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(104.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(125.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(62.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(83.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(104.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(146.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(41.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(125.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(167.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-3",
    transform: "translate(42.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_checked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(21.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(42.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(84.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape-Checks",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(63.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomDataDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CustomDataDownload.51b6544b5fb22962e60549f849b3f5b2.svg";